<div class="workspace-layout" *ngIf="pageContent" [ngStyle]="{'height': pageContent.PageIsFixedSize ? '100%' : 'auto'}">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
    <div class="main-grid-container"
    [ngStyle]="{'grid-template-columns': gridColumns,
    'grid-template-rows': gridRows, '-ms-grid-columns': msGridColumns, '-ms-grid-rows': msGridRows}">
    <div class="document-debug" style="display: none;">
        EPIC Page Name: {{pageContent.EPICPageName}}
    </div>
        <ng-container *ngIf="pageContent.Content">
            <div class="main-grid-item" *ngFor="let content of pageContent.Content" 
            [ngStyle]="{'grid-column': getGridConfig(content.EPICGroupId, 'startColumn') + ' / span '+ getGridConfig(content.EPICGroupId, 'width'), 
            'grid-row': getGridConfig(content.EPICGroupId, 'startRow') + ' / span ' + getGridConfig(content.EPICGroupId, 'height'),
            '-ms-grid-column': getGridConfig(content.EPICGroupId, 'startColumn'), '-ms-grid-column-span': getGridConfig(content.EPICGroupId, 'width'), 
            '-ms-grid-row': getGridConfig(content.EPICGroupId, 'startRow'), '-ms-grid-row-span': getGridConfig(content.EPICGroupId, 'height')}">
                <app-reportgroup [pageContent]="pageContent" 
                [getReportGroup]="{EPICPageId: pageContent.EPICPageId, EPICContentId: content.EPICContentId}" 
                (setFixedHeight)="setGridRows($event, content.PositionY)" [isFixHeight]="pageContent.PageIsFixedSize"
                [posX]="content.PositionX" [posY]="content.PositionY" (emitReportGroup)="setReportGroup($event)"></app-reportgroup>
            </div>
        </ng-container>
    </div>

    <!-- testing new boostrap layout, basically expected layout  -->
    <!-- <div class="container-fluid">
        <div class="row">
            <ng-container *ngFor="let content of pageContent.Content; let i=index">
            <div class="container-fluid col-md-12 col-sm-12" [id]="content.EPICContentId">
                <app-reportgroup [setReportGroup]="{EPICPageId: pageContent.EPICPageId, EPICContentId: content.EPICContentId}" 
                [pageContent]="pageContent" (setFixedHeight)="setGridRows($event, content.PositionY)" 
                [isFixHeight]="pageContent.PageIsFixedSize" [posX]="content.PositionX" [posY]="content.PositionY">
                </app-reportgroup>
            </div>
            </ng-container>
        </div>
    </div> -->
</div>


